export default {
    actions: {},

    mutations: {
        updateCatalogLinks(state, foo) {
            state.catalogLinks = foo;
        }
    },

    state() {
        return {
            catalogLinks: [],
            httpLink: "/frontend/",
            baseUpload: "https://pos.buum.uz/uploads/products/",
            baseUploadSecond: "https://pos.buum.uz/uploads/products/medium/"
        };
    },

    getters: {
        catalogLinks(state) {
            return state.catalogLinks;
        },

        httpLink(state) {
            return state.httpLink;
        },

        baseUpload(state) {
            return state.baseUpload;
        },

        baseUploadSecond(state) {
            return state.baseUploadSecond;
        }
    }
};
